export type CheckResponse =
  | {
      result: "success"
      refreshToken: string
    }
  | {
      result: "error"
      error: string
    }
  | {
      result: "cancelled"
    }

export type OpenAuth = (
  getAuthUrl: () => Promise<string>,
  onClose: (response: CheckResponse) => void,
) => unknown

type AuthResultMessage = {
  data: {
    type: string
  } & CheckResponse
}

export const windowMessageType = "oauthResult"

const openAuth: OpenAuth = async (getUrl, onClose) => {
  window.addEventListener(
    "message",
    ({ data }: AuthResultMessage) => {
      if (data.type !== windowMessageType) {
        return
      }

      onClose(data)
    },
    false,
  )

  const width = 500
  const height = 660
  const left = window.screenX + (window.outerWidth - width) / 2
  const top = window.screenY + (window.outerHeight - height) / 2.5

  window.open(
    await getUrl(),
    "oauth",
    `toolbar=no,menubar=no,width=${width},height=${height},top=${top},left=${left}`,
  )
}

export default openAuth
